import React from "react";
import { useDispatch } from "react-redux";
import { changeAuth } from "../actions/loginAction";
import { useNavigate } from "react-router-dom";
import pdffile from "../assets/images/pdf-file.svg";
import pdfthumbail from "../assets/images/image.png";
import FileActions from "./file-actions";
import { LinearProgress } from "@mui/material";
import LinearWithValueLabel from "./pdf-grid-status";
import host from "../host";
import docicon from "../assets/images/docx.jpg";
import excelicon from "../assets/images/excel.jpg";
import websiteIcon from "../assets/images/type_website.png";
const PdfThumbnail = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getSignedPdf = (pdf) => {
    fetch(host.chaturl + `/knowledge/file/${pdf.id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        }
      })
      .then((data) => {
        props.toggleDrawer(data.file_path, pdf.file_name, pdf.id);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSelectPdf = (event, pdf) => {
    if (pdf.status !== "completed") {
      return;
    } else if (event.ctrlKey) {
      if (props.selectedPDFs.includes(pdf)) {
        props.setSelectedPDFs(props.selectedPDFs.filter((selectedPdf) => selectedPdf !== pdf));
      } else {
        props.setSelectedPDFs([...props.selectedPDFs, pdf]);
      }
      return;
    } else {
      getSignedPdf(pdf);
      return;
    }
  };

  const getFileStatusUpdate = (index, pdfDataId) => {
    fetch(host.chaturl + `/knowledge/file/${pdfDataId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
      })
      .then((data) => {
        if (data) {
          if (data._id === props.pdfListData[index].id) {
            props.setPdfListData((prevPdfListData) => {
              const newDataArray = [...prevPdfListData];
              newDataArray[index] = {
                ...newDataArray[index],
                status: data.status,
              };
              return newDataArray;
            });
          } else {
            console.log("Data id does not match at index ", index);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getIcon = (fileName, doc_type) => {
    if (doc_type === "url") {
      return websiteIcon;
    } else if (doc_type === null) {
      const fileParts = fileName?.split(".");
      const fileExtension = fileParts[fileParts?.length - 1];
      if (fileExtension === "pdf") {
        return pdffile;
      } else if (fileExtension === "docx") {
        return docicon;
      } else if (fileExtension === "xlsx") {
        return excelicon;
      } else {
        return pdffile;
      }
    } else {
      return pdffile;
    }
  };

  return (
    <>
      {props?.pdfListData?.map((pdfData, index) => (
        <div className={`pdf_thumbnail_box ${props.selectedPDFs.includes(pdfData) ? "selected" : ""}`} key={index} onClick={(event) => handleSelectPdf(event, pdfData)}>
          <div className="thumbnail-progress">
            {pdfData.status === "completed" && <LinearProgress variant="determinate" value={100} color="success" />}
            {pdfData.status === "failed" && <LinearProgress variant="determinate" value={100} color="error" />}
            {pdfData.status === "processing" && <LinearWithValueLabel pdfData={pdfData} getFileStatusUpdate={getFileStatusUpdate} index={index} getKnowledge={props.getKnowledge} />}
          </div>
          <div className="pdf_thumbnail_head">
            <div className="pdficon">
              <img src={getIcon(pdfData.file_name ? pdfData.file_name : null, pdfData.doc_type ? pdfData.doc_type : null)} height={25} alt="" />
            </div>
            <div className="pdf_thumbnail_title">{pdfData.file_name ? pdfData.file_name : pdfData.url ? pdfData.url : "NA"}</div>
            <div className="pdf_actions" onClick={(event) => event.stopPropagation()}>
              <FileActions
                pdfFilePath={pdfData.file_path}
                pdfFileName={pdfData.file_name}
                pdfId={pdfData.id}
                getKnowledge={props.getKnowledge}
                handleChatSpecificDoc={props.handleChatSpecificDoc}
                pdfData={pdfData}
              />
            </div>
          </div>
          <div className="pdf_thumbnail_body">
            <div className="pdf_thumbnail_view">
              <img src={pdfData?.doc_type === "url" ? websiteIcon : pdfData?.thumbnail_url ? pdfData.thumbnail_url : pdfthumbail} alt="" />
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
export default PdfThumbnail;
